import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { LoanApplicationOfferResponse } from "@interfaces/MarketPlace";
import { formatCurrency } from "@helpers/funciones";
import { Button } from "@mui/material";


const BORDER_COLOR = "#A3D4E8";

const StyledTableCell = styled(TableCell)(() => ({
  border: `1px solid ${BORDER_COLOR}`,
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#052649",
    color: "#fff",
    fontWeight: 500,
    border: `1px solid ${BORDER_COLOR}`,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 15,
    color: "#002652",
    border: `1px solid ${BORDER_COLOR}`,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#fff", // Filas impares blancas
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#E3F2F8", // Filas pares color claro
  },
  "&:last-child td, &:last-child th": {
    border: `1px solid ${BORDER_COLOR}`, // mantiene borde inferior
  },
}));

interface TableCreditOfferProps {
  offer: LoanApplicationOfferResponse[];
  onSelectOffer?: (offer: LoanApplicationOfferResponse) => void;
  isLoading?: boolean;
}

export default function TablaOfertas({ offer, onSelectOffer, isLoading }: TableCreditOfferProps) {

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">Entidad Financiera</StyledTableCell>
            <StyledTableCell align="center">Monto</StyledTableCell>
            <StyledTableCell align="center">Plazo Maximo</StyledTableCell>
            <StyledTableCell align="center">Tasa</StyledTableCell>
            <StyledTableCell align="center">Comisiones</StyledTableCell>
            <StyledTableCell align="center">Garantía</StyledTableCell>
            <StyledTableCell align="center">Seleccionar</StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {offer.map((row) => (
            <StyledTableRow key={row.id}>
              <StyledTableCell component="th" scope="row">
                {row.financial_company.name}
              </StyledTableCell>
              <StyledTableCell align="center">
                {formatCurrency(row.loan_amount || 0)} <span style={{ fontSize: 11 }}>MXN</span>
              </StyledTableCell>
              <StyledTableCell align="center">{row.details?.maxAuthorizedPeriod} meses</StyledTableCell>
              <StyledTableCell align="center">{row.details?.interestRate}%</StyledTableCell>
              <StyledTableCell align="center">{row.details?.openingFee}%</StyledTableCell>
              <StyledTableCell align="center">{row.details?.guaranteeDetails}</StyledTableCell>
              <StyledTableCell align="center">
                <Button
                  variant="yellow"
                  sx={{ fontSize: "13px" }}
                  disabled={isLoading}
                  onClick={() => onSelectOffer?.(row)}
                >
                  Elegir Oferta
                </Button>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
